import React, { useState } from 'react';
import { Nav, Accordion } from 'react-bootstrap';
import { FaTruck, FaListAlt, FaMapMarkerAlt } from 'react-icons/fa';
import './NavbarManageComponent.css'; // Đảm bảo CSS được import

const NavbarCustomerComponent = ({ setComponentDuocChon, isSidebarOpen, toggleSidebar }) => {
  const [activeLink, setActiveLink] = useState('dashboard'); // Quản lý trạng thái active của link

  // Xử lý khi chọn link và đóng sidebar trên mobile
  const handleLinkClick = (component) => {
    setActiveLink(component);
    setComponentDuocChon(component);

    // Đóng sidebar trên mobile
    if (window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  return (
    <div
      id="navbar-sidebar"
      className={`bg-white vh-100 p-1 pt-3 border-end shadow-sm ${isSidebarOpen ? 'show' : ''}`}
      style={{
        width: window.innerWidth > 768 ? '16.67%' : isSidebarOpen ? '60%' : '0', // Sidebar luôn hiển thị trên desktop (16.67%), toggle trên mobile (60%)
        height: '100vh',
        position: window.innerWidth > 768 ? 'fixed' : 'absolute', // Fixed trên desktop, absolute trên mobile
        top: '80px', // Đẩy xuống dưới header
        left: 0,
        zIndex: 999, // Đảm bảo sidebar luôn trên cùng khi mở
        transition: 'transform 0.4s ease, opacity 0.4s ease', // Hiệu ứng khi mở/đóng
        transform: isSidebarOpen || window.innerWidth > 768 ? 'translateX(0)' : 'translateX(-100%)',
        opacity: isSidebarOpen || window.innerWidth > 768 ? 1 : 0,
      }}
    >
      <Accordion defaultActiveKey="0" flush className="flex-grow-1">
        <Accordion.Item eventKey="0">
          <Nav className="flex-column">
            <Nav.Link
              className={`sidebar-link ${activeLink === 'datDon' ? 'active' : ''}`}
              onClick={() => handleLinkClick('datDon')}
              style={{
                color: activeLink === 'datDon' ? '#dc3545' : 'black',
                padding: '10px 15px',
                borderRadius: '50px',
                backgroundColor: activeLink === 'datDon' ? '#f8d7da' : 'transparent',
              }}
            >
              <FaTruck className="me-2" /> Đặt Xe Chở Hàng
            </Nav.Link>
          </Nav>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Nav className="flex-column">
            <Nav.Link
              className={`sidebar-link ${activeLink === 'donHang' ? 'active' : ''}`}
              onClick={() => handleLinkClick('donHang')}
              style={{
                color: activeLink === 'donHang' ? '#dc3545' : 'black',
                padding: '10px 15px',
                borderRadius: '50px',
                backgroundColor: activeLink === 'donHang' ? '#f8d7da' : 'transparent',
              }}
            >
              <FaListAlt className="me-2" /> Quản Lý Đơn Hàng
            </Nav.Link>
          </Nav>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Nav className="flex-column">
            <Nav.Link
              className={`sidebar-link ${activeLink === 'theoDoiDonHang' ? 'active' : ''}`}
              onClick={() => handleLinkClick('theoDoiDonHang')}
              style={{
                color: activeLink === 'theoDoiDonHang' ? '#dc3545' : 'black',
                padding: '10px 15px',
                borderRadius: '50px',
                backgroundColor: activeLink === 'theoDoiDonHang' ? '#f8d7da' : 'transparent',
              }}
            >
              <FaMapMarkerAlt className="me-2" /> Theo Dõi Đơn Hàng
            </Nav.Link>
          </Nav>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Nav className="flex-column">
            <Nav.Link
              className={`sidebar-link ${activeLink === 'chatBox' ? 'active' : ''}`}
              onClick={() => handleLinkClick('chatBox')}
              style={{
                color: activeLink === 'chatBox' ? '#dc3545' : 'black',
                padding: '10px 15px',
                borderRadius: '50px',
                backgroundColor: activeLink === 'chatBox' ? '#f8d7da' : 'transparent',
              }}
            >
              <FaMapMarkerAlt className="me-2" /> Kết Nối Với Nhân Viên
            </Nav.Link>
          </Nav>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default NavbarCustomerComponent;
